import React from "react";
import {
  CModal,
  CModalBody,
  CModalHeader,
  CModalTitle,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableRow,
} from "@coreui/react";
import { Image } from "react-bootstrap";
import crossIcon from "../../../assets/images/cross-icon-custom.png";

const OtherInfoModal = (props) => {
  return (
    <CModal
      className="otherInfoModal"
      size="lg"
      backdrop="static"
      visible={props?.showOtherInfo}
      onClose={() => props?.setShowOtherInfo(false)}
      alignment="center"
    >
      <CModalHeader closeButton={false}>
        <CModalTitle>Vehicle Details</CModalTitle>
        <button
          className="custom-close-btn"
          onClick={() => props?.setShowOtherInfo(false)}
        >
          <Image src={crossIcon} alt="material-symbols-info-icon" />
        </button>
      </CModalHeader>
      <CModalBody>
        <CTable className="table-bordered card--data-tables mb-15">
          <CTableBody>
            <CTableRow className="data-border">
              <CTableDataCell>
                <div className="otherInfo-td-div">
                  <span className="data-label-s">Registration Number</span>
                  <span className="data-model-val">
                    {props?.vehicleTrackingData?.vehicleNo}
                  </span>
                </div>
              </CTableDataCell>
              <CTableDataCell>
                <div className="otherInfo-td-div">
                  <span className="data-label-s">Registration Date</span>
                  <span className="data-model-val">
                    {props?.vehicleTrackingData?.registrationDate}
                  </span>
                </div>
              </CTableDataCell>
            </CTableRow>
            <CTableRow className="data-border">
              <CTableDataCell>
                <div className="otherInfo-td-div">
                  <span className="data-label-s">Chassis Number</span>
                  <span className="data-model-val">
                    {props?.vehicleTrackingData?.vehicleChassisNo}
                  </span>
                </div>
              </CTableDataCell>
              <CTableDataCell>
                <div className="otherInfo-td-div">
                  <span className="data-label-s">Engine Number</span>
                  <span className="data-model-val">
                    {props?.vehicleTrackingData?.vehicleEngineNo}
                  </span>
                </div>
              </CTableDataCell>
            </CTableRow>
            <CTableRow className="data-border">
              <CTableDataCell>
                <div className="otherInfo-td-div">
                  <span className="data-label-s">Make Model</span>
                  <span className="data-model-val">
                    {props?.vehicleTrackingData?.vehicleMakeModel}
                  </span>
                </div>
              </CTableDataCell>
              <CTableDataCell>
                <div className="otherInfo-td-div">
                  <span className="data-label-s">Model Year</span>
                  <span className="data-model-val">
                    {props?.vehicleTrackingData?.modelYear}
                  </span>
                </div>
              </CTableDataCell>
            </CTableRow>
          </CTableBody>
        </CTable>
      </CModalBody>
    </CModal>
  );
};

export default OtherInfoModal;
